export default {
  common: {
    home: 'Главная',
    dashboard: 'Дэшборд',
    reports: 'Отчеты',
    accounts: 'Анкеты',
    messages: 'Сообщения',
    staff: 'Персонал',
    credentials: 'ADM',
    daemons: 'Синхронизация',
    plugin: 'Плагин',
    profile: 'Профиль',
    letters: 'Письма',
    statistics: 'Статистика',
    agency: 'Агенство',
    clients: 'Клиенты',
    logout: 'Выход',
    calendar: 'Календарь',
    calendar2: 'Календарь',
    archives: 'Архивы',
    clearCache: 'Почистить кеш',
    transfers: 'История переводов',
    contactInfo: 'Контактная информация',
    gifts: 'Подарки',
    payers: 'Список платящих',
    settings: 'Настройки',
    proxies: 'Прокси',
    settingPermissions: 'Права доступа',
    general: 'Профили',
    wallet: 'Кошелек',
    close: 'Закрыть',
    chats: 'Чаты',
  },
  tableFilter: {
    period: '',
    from: 'от',
    to: 'до',
    sorting: 'сортировка',
    grouping: 'груп',
    status: 'статус',
    search: 'поиск',
    columns: 'столбцы',
    saveAs: 'Сохранить как...',
    filtering: 'фильтрация',
    all: 'Все'
  },
  dashboardFilter: {
    period: 'период',
    elements: 'элементы',
    from: 'от',
    to: 'до',
  },
  login: {
    enter: 'Войти',
    register: 'Зарегистрироваться',
    remindPassword: 'Напомнить пароль',
    alreadyRegistered: 'Уже есть аккаунт'
  },
  plugin: {
    mails: 'Письма',
    chats: 'Чаты',
    templatesCount: 'Шаблоны',
    sentTotal: 'Разослано',
    other: 'Другое'
  },
  popup: {
    noResults: 'Нет результатов',
    selectPlaceholder: 'Выбрать...'
  },
  letters: {
    sender: 'Отправитель',
    recipient: 'Получатель',
    recipientAvatar: 'Аватар',
    date: 'Дата',
    free: 'Бесплатное',
    flirt: 'Флирт',
    read: 'Прочитано',
    doRead: 'Читать',
    yes: 'Да',
    no: 'Нет'
  },
  operatorsTab: {
    shiftGreaterError: 'Нельзя создать смену с датой начала позже даты окончания',
    shiftToError: 'Неверное значение даты окончания',
  },
  links: {
    copied: 'Скопировано !',
    share: 'Поделиться',
    copyLink: 'Копировать ссылку',
    trialLink: 'Триальная ссылка',
    tackingLink: 'Трекинг ссылка',
    Clicks: 'Клики',
    Claims: 'Заявки',
    Revenue: 'Доход',
    Watch: 'Просмотр',

    trials: "Триалы",
    trackings: "Трекинги",
    transfers: "Переводы",
  },
};
